import jmsTable from './jms-table/index.vue'

export default {
  install(Vue, opts = {}) {
    Vue.component('jms-table', jmsTable)
  }
}
